export const fileTypes = {
  JSON: 'json',
  YAML: 'yaml',
  COMMON_JS: 'common-js',
  ES_MODULE: 'es-module',
  JAVASCRIPT: 'javascript',
  INI: 'initialization'
};

export const fileTypeExtensions = {
  [fileTypes.JSON]: 'json',
  [fileTypes.YAML]: 'yml',
  [fileTypes.COMMON_JS]: 'cjs',
  [fileTypes.ES_MODULE]: 'mjs',
  [fileTypes.JAVASCRIPT]: 'js',
  [fileTypes.INI]: 'ini'
};
